import React, { Component } from 'react'
import { Row, message, Tooltip, Divider, Table, Spin, Space } from 'antd';
import { Close } from '@material-ui/icons';
import { CustomStats, CustomStatsSmall } from './custom_stat';
import { RESTExecutor, withDomains } from '../lib/domain';
import { formatMoney } from '../lib/util';
import ErrorWrapper from '../lib/error_wrapper';
import { COLORS } from '../pages/theme';


const daily_aggregation_cols = ({ }) => [
    {
        title: "TXN DATE",
        dataIndex: 'txn_date',
        key: 'txn_date'
    },
    {
        title: "DR COUNT",
        dataIndex: 'dr_count',
        key: 'dr_count',
        className: 'right-align',
        render: (value, record) => <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
        }}>
            {/* {value > 0 ? <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/packets`,
                search: queryString.stringify({
                    fetcher_response_id: record.fetcher_response_id
                })
            }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :  */}
            <span className='right-align'>{formatMoney(value, 0)}</span>
            {/* } */}
        </div>
    },
    {
        title: "DR TOTAL",
        dataIndex: 'dr_amount',
        key: 'dr_amount',
        className: 'right-align',
        render: (value, record) => <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
        }}>
            {/* {value > 0 ? <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/packets`,
                search: queryString.stringify({
                    fetcher_response_id: record.fetcher_response_id
                })
            }}>  <span className='right-align'>{formatMoney(value, 2)}</span></Link> :  */}
            <span className='right-align'>{formatMoney(value, 2)}</span>
            {/* } */}
        </div>
    },
    {
        title: "CR COUNT",
        dataIndex: 'cr_count',
        key: 'cr_count',
        className: 'right-align',
        render: (value, record) => <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
        }}>
            {/* {value > 0 ? <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/packets`,
                search: queryString.stringify({
                    fetcher_response_id: record.fetcher_response_id
                })
            }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :  */}
            <span className='right-align'>{formatMoney(value, 0)}</span>
            {/* } */}
        </div>
    },
    {
        title: "CR TOTAL",
        dataIndex: 'cr_amount',
        key: 'cr_amount',
        className: 'right-align',
        render: (value, record) => <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end'
        }}>
            {/* {value > 0 ? <Link to={{
                pathname: `/activity/data-type/${record.data_type_id}/packets`,
                search: queryString.stringify({
                    fetcher_response_id: record.fetcher_response_id
                })
            }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :  */}
            <span className='right-align'>{formatMoney(value, 2)}</span>
            {/* } */}
        </div>
    }
]
class ModalPacketDetailView extends Component {

    static defaultProps = {
        onClose: () => { }
    }

    constructor(props) {
        super(props)

        this.packet_id = props.match.params.packet_id;

        this.state = {
            loading: true,
            filter_data:{
                per_page:100,
                page:1
            }
        }
        // this.get_detail = RESTExecutor.detail().forId(this.packet_id).config({
        //     label: 'packet_detail'
        // }).callbacks((success) => {
        //     this.setState({
        //         loading: false
        //     })
        //     this.get_aggregations.execute();
        // }, (error) => {
        //     this.setState({
        //         loading: false
        //     })
        // }).connect(props.domains.activity)

        this.get_aggregations = RESTExecutor.detail().forId(this.packet_id).config({
            label: 'packet_overview',
            params:{
                ...this.state.filter_data
            }
        }).callbacks(() => {
            this.setState({ loading: false })
        }, (error) => {
            this.setState({ loading: false })
        }).connect(props.domains.activity)

    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }


    render() {
        if (this.state.loading) {
            return <center><Spin /></center>
        }
        let get_aggregations_resp = this.get_aggregations.response();
        let rowsData = (get_aggregations_resp.result && get_aggregations_resp.result.rows) || [];
        let rowsMeta = get_aggregations_resp.meta || {};
        let selected_packet = this.props.selected_packet || {};

        let label = selected_packet.transferred ?
            selected_packet.manual_transfer ? "M" : "A" :
            selected_packet.transferred == false ? "Q" :
                selected_packet.un_transfer == true ? "U" : ""


        let status = selected_packet.transferred;


        return (
            <div className='default-card' style={{ padding: 0, margin: 0 }}>
                <Row type='flex' justify='space-between' align='middle' style={{
                    flexWrap: 'nowrap'
                }} >
                    <Row type='flex' style={{
                        flex: 1,
                        alignItems: 'center',
                        paddingLeft: 20,
                        paddingRight: 20,
                        justifyContent: 'space-between',
                        paddingTop: 20,
                        paddingBottom: 6,
                        borderBottom:`1px solid ${COLORS.border_basic}`
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        }}>
                            <Space size={20}>
                                <div
                                    className={status ? 'text-tag-success' : 'text-tag-danger'}
                                    style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                    {label}
                                </div>
                                <CustomStats label='SOURCE' title={selected_packet.source_id} />
                            </Space>
                        </div>

                        {typeof this.props.onClose === 'function' &&
                            <div style={{
                                // width: 100,
                                paddingLeft: 20,
                                // paddingRight: 20,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center'
                            }}>
                                <Close className='hand-cursor' onClick={() => {
                                    if (typeof this.props.onClose === 'function') {
                                        this.props.onClose();
                                    } else {
                                        message.error("Please define onClose function")
                                    }
                                }} />
                            </div>}
                        {/* <CustomStats label='CREATED AT' title={"2020-06-11 06:59:51 AM"} />
                       
                        <CustomStats label='TXN COUNT' title={"140"} />
                        <CustomStats label='TRANSFER STATUS' content={<div style={{
                            display: 'flex', flexDirection: 'row',
                            height: 36,
                            lineHeight: '120%',
                            alignItems: 'center'
                        }}>
                            <Tooltip arrowPointAtCenter placement='bottomLeft' title={"Transferred"} key={'0'} >
                                <div className={true ? 'reconciled-indicator' : 'not-reconciled-indicator'}></div></Tooltip>

                        </div>} /> */}
                    </Row>



                </Row>
                {/* <Divider style={{
                    marginTop: 0,
                    marginBottom: 12
                }} />
                <Row type='flex' style={{
                    paddingLeft: 20,
                    justifyContent: 'space-between',
                    paddingRight: 20,
                    // paddingTop: 12
                }}>
                    <CustomStatsSmall label='MIN TXN DATE' title={"2020-06-11" || "N/A"} />
                    <CustomStatsSmall label='MAX TXN DATE' title={"2020-06-11"} />
                    <CustomStatsSmall label='SOURCE' title={"TERM147"} />

                </Row>
               */}
                {/* <Divider style={{
                    marginTop: 0,
                    marginBottom: 12
                }} /> */}
                <ErrorWrapper error={get_aggregations_resp}
                    onReload={() => {
                        this.setState({
                            loading: true
                        });
                        this.get_aggregations.execute();
                    }}>
                    <Table
                        className='main-table'
                        size='small'
                        dataSource={rowsData}
                        loading={get_aggregations_resp.fetching}
                        columns={daily_aggregation_cols({

                        })}
                        pagination={{
                            simple: false,
                            size: 'small',
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.stateUpdater({
                                  stateKey:'filter_query',
                                  appendObj:{
                                    per_page:size,
                                    page:current
                                  },
                                  callback:()=>{
                                    this.get_aggregations.config({
                                      params:{
                                        ...this.state.filter_query
                                      }
                                    }).execute();
                                  }
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            // defaultPageSize: 20,
                            pageSize: (rowsMeta && rowsMeta.requested_count),
              
                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}


                    />
                </ErrorWrapper>

            </div>
        )
    }

    componentDidMount() {
        this.get_aggregations.execute()
    }


    componentDidUpdate = (prevProps) => {
        if (this.props.match.params.packet_id !== prevProps.match.params.packet_id) {
            this.packet_id = this.props.match.params.packet_id;
            this.setState({
                loading: true,
            })
            this.get_aggregations.forId(this.packet_id).execute()
            // this.get_detail.forId(this.packet_id).execute()
            // fetch the new product based and set it to the state of the component
        };
    }

}

export default withDomains(ModalPacketDetailView, "activity")
